import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Grid,
    IconButton,
    Button,
    InputAdornment,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles, 
} from '@material-ui/core';
import * as logger from '../../../logger';
import CloseIcon from '@material-ui/icons/Close';
import TextInputState from '../Inputs/TextInputState';
import { Form } from 'react-final-form';
import { editBankDetails } from '../../../store/actions/OnlinePaymentActionCreators';


const useStyles = makeStyles(() => ({

    dialogV1: {
        borderRadius: '8px !important'
    },
    widthV1: {
        maxWidth: '420px !important'
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingTop: 8,
        paddingBottom: '8px !important',
        paddingRight: 12
    },
    divAlignTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 600
    },
    closeIconV1: {
        color: '#D0D0D0',
        fontSize: 20
    },
    titleV1: {
        fontWeight: 600,
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV2: {
        marginTop: 4
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 32,
        paddingBottom: 32,
        backgroundColor: '#f6f6f8'
    },
    closeButton: {
        borderRadius: '4px !important',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 6,
        paddingBottom: 6,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#3e3f42',
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#161f34',
        color: 'white',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#161f34'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#e2e2e2 !important',
        color: 'rgba(11, 19, 35, 0.6) !important',
        fontWeight: 300,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e2e2e2 !important'
        }
    },
    dialogActionsV1: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingRight: 30,
        paddingLeft: 30
    },
    brV1: {
        borderRadius: '8px !important'
    }

}));

const UpdateBankUpiDialog = ({ open, onClose, onConfirm, bankId, dispatchEditBankDetails }) => {

    let submit;

    const [dialogOpen, setDialogOpen] = useState(open);
    const [upiAddressValue, setUpiAddressValue] = useState("");
    const [dialogConfirmDisabled, setDialogConfirmDisabled] = useState(false);

    const classes = useStyles();

    const initialValues = {
        upiAddress: upiAddressValue
    }

    const getFormFields = (values) => {
        return [
            {
                size: 12,
                visible: true,
                field: (
                    <div>
                        <div className={classes.titleV1}>UPI Address</div>
                        <TextInputState
                            placeholder="Enter UPI Address"
                            name="upiAddress"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            multiline={true}
                            onChange={(e) => { setUpiAddressValue(e.target.value) }}
                            className={classes.mtV2}
                            classes={{ root: classes.textFieldV1 }}
                        />
                    </div>
                )
            }
        ]
    }

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onSubmit = values => {

        const bankData = {
            upi_address: values.upiAddress
        }

        dispatchEditBankDetails(bankId, bankData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('Update Bank Upi Dialog Dweb', 'Edit Bank Details Successfull');
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            () => {
                logger.log('Update Bank Upi Dialog Dweb', 'Edit Bank Details Failed');
            }
        )

    }

    const validate = values => {

        let config = JSON.parse(localStorage.getItem("USER_APP_CONFIG"));
        let upiAddressValidation = config && config.upi_id_regex ? new RegExp(config.upi_id_regex) : "";

        let upiAddressLowerCase = values.upiAddress ? (values.upiAddress).toLowerCase() : "";

        const errors = {};

        if ((values.upiAddress && (!upiAddressValidation.test(upiAddressLowerCase))) || (!values.upiAddress)) {
            errors.upiAddress = "Please enter a Valid UPI Address"
        }

        if (errors && Object.keys(errors).length !== 0 && errors.constructor === Object) {
            setDialogConfirmDisabled(true);
        } else {
            setDialogConfirmDisabled(false);
        }

        return errors;
    }

    return (
        <>
            <Dialog fullWidth={true} maxWidth='xs' onClose={handleDialogClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="trip-amount-edit-dialog-title" open={dialogOpen} className={classes.dialogV1} classes={{ paperWidthXs: classes.widthV1, paper: classes.brV1 }} >
                <DialogTitle id="update-bank-upi-dialog-title" className={classes.dialogTitleV1}>
                    <div className={classes.divAlignTitle} >
                        <div className={classes.divTitle} >
                            Add UPI Address
                        </div>
                        <div>
                            <IconButton onClick={handleDialogClose}>
                                <CloseIcon className={classes.closeIconV1} />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>

                <DialogContent dividers className={classes.dialogContentV1}>

                    <Form
                        onSubmit={onSubmit}
                        keepDirtyOnReinitialize
                        initialValues={initialValues}
                        validate={validate}
                        render={({ handleSubmit, form, submitting, pristine, values }) => {
                            submit = handleSubmit; return (
                                <form onSubmit={handleSubmit} noValidate>
                                    <Grid container className={classes.paymentForm} alignItems="flex-start" spacing={0}>
                                        {getFormFields(values).map((item, idx) => item.visible ? (
                                            <Grid item xs={item.size} key={idx}>
                                                {item.field}
                                            </Grid>
                                        ) : null)}
                                    </Grid>
                                </form>
                            )
                        }}
                    />

                </DialogContent>

                <DialogActions className={classes.dialogActionsV1} >
                    <Button variant="contained" className={classes.closeButton} onClick={handleDialogClose} >
                        Close
                    </Button>
                    <Button className={classes.saveButton} variant="contained" onClick={(event) => submit(event)} disabled={dialogConfirmDisabled} classes={{ disabled: classes.saveButtonDisabled }} >
                        Confirm
                    </Button>
                </DialogActions>

            </Dialog>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

    dispatchEditBankDetails: (bankId, data, onSuccess, onError) => {
        dispatch(editBankDetails(bankId, data, onSuccess, onError))
    }

});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateBankUpiDialog)